// extracted by mini-css-extract-plugin
export default {"more-operation-wrap":"index_more-operation-wrap__dwNAq"};